export var shallowDiffers = function (a, b) {
    if ((!a && b) || (!b && a)) {
        return true;
    }
    for (var i in a) {
        if (!(i in b)) {
            return true;
        }
    }
    for (var i in b) {
        if (b.hasOwnProperty(i) && a[i] !== b[i]) {
            return true;
        }
    }
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/shallowDiffers.ts
// module id = 131
// module chunks = 3